angular.module('SpidApp')

.factory('Drawer',
		['$http', 'SPID_CONFIG', '$q',
function ($http,   SPID_CONFIG,   $q) {
	var CONFIG = SPID_CONFIG.devices.drawer

    var HOST = CONFIG.host
    var PORT = CONFIG.port
    
    var IS_MOCKED = CONFIG.isMocked
	
	var Drawer = {
		_getRoute: function () {
			return HOST + ':' + PORT + '/drawer'
		},
		getStatus: (IS_MOCKED ? function () {
			return $q(function (resolve) { resolve() })
		} : function () {
			return $http.get(this._getRoute()).then(function (response) {
				return $q(function (resolve, reject) {
					if (response.data.code === 0 ||
						response.data.code === 1 ||
						response.data.code === 2) {
						resolve(response.data)
					}
					
					reject(response.data)
				})
			})
		}),
		open: function () {
			return $http.get(this._getRoute() + '/open').then(function (response) {
				return response
			})
		}
	}

	return Drawer
}])